import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { SavedSearchFilterInput } from '@/graphql/contracts/_generated_/contracts';
import {
  GetSavedSearches,
  GetSavedSearchesVariables,
} from '@/graphql/contracts/_generated_/getSavedSearches.query';
import GetSavedSearchesQuery from '@/graphql/contracts/getSavedSearches.query.gql';

export default function useGetSavedSearchQuery() {
  const getSavedSearchQuery = async ({ form, rowKey }: SavedSearchFilterInput) => {
    const response = await apolloClientContracts.query<GetSavedSearches, GetSavedSearchesVariables>(
      {
        query: GetSavedSearchesQuery,
        variables: {
          filter: { form, rowKey },
        },
      },
    );

    return response.data?.savedSearches;
  };

  return {
    getSavedSearchQuery,
  } as const;
}
